const ACL_STYLE_SHEET = 'acl-style-sheet';
const ACL_VIEW_NAME_PREFIX = 'acl_view_name';

export const getAclViewClassName = (key: string) => `${ACL_VIEW_NAME_PREFIX}_${key.toLowerCase()}`;

export const createAclStyleSheet = (restrictedViewsArray: string[]) => {
    const style = document.createElement('style');
    style.id = ACL_STYLE_SHEET;
    let styles = '';
    restrictedViewsArray.forEach((view) => {
        styles += `.${ACL_VIEW_NAME_PREFIX}_${view.toLowerCase()} {
            display: none !important;
        }\n\n`;
    });
    style.textContent = styles;
    document.head.appendChild(style);
    console.log('ACL Stylesheet created!');
};

export const deleteAclStyleSheet = () => {
    const style = document.getElementById(ACL_STYLE_SHEET);
    if (style) {
        style.remove();
        console.log('ACL Stylesheet deleted!');
    } else {
        console.log('No acl stylesheet found to delete.');
    }
};
